export const CONSULTA_MAX = 300
export const CONSULTA_MIN = 10
export const RESPUESTA_MAX = 500

export const CATEGORIAS_CONSULTA = [
  ['general', 'General'],
  ['beneficios', 'Beneficios'],
  ['cursos_acle', 'Cursos y ACLE'],
  ['actividades', 'Actividades'],
  ['tesoreria', 'Cuotas / Tesorería'],
  ['otro', 'Otro'],
]

export const categoriaLabel = (value) => CATEGORIAS_CONSULTA.find(([key]) => key === value)?.[1] ?? 'Otro'

export const ESTADOS_CONSULTA = {
  pendiente: { label: 'Pendiente', className: 'border-pending/30 bg-pending/10 text-pending' },
  respondida: { label: 'Respondida', className: 'border-success/30 bg-success/10 text-success-text' },
  cerrada: { label: 'Cerrada', className: 'border-border bg-background text-text-secondary' },
}

export function formatConsultaDate(value) {
  if (!value) return ''
  return new Intl.DateTimeFormat('es-CL', { timeZone: 'America/Santiago', day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(value)).replace(/\//g, '-')
}
